'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require('react-redux');

var _assets = require('redux/modules/assets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuggestTagDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    suggesting: state.assets.suggestingTag,
    suggested: state.assets.tagSuggested
  };
}, null, null, {
  withRef: true
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(SuggestTagDialog, _React$Component);

  function SuggestTagDialog() {
    (0, _classCallCheck3.default)(this, SuggestTagDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SuggestTagDialog.__proto__ || (0, _getPrototypeOf2.default)(SuggestTagDialog)).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SuggestTagDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.dispatch((0, _assets.resetSuggestTag)());

      setTimeout(function () {
        _this2.refs.textarea.focus();
      }, 100);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.suggested && nextProps.suggested) {
        setTimeout(this.forceClose.bind(this), 3000);
      }
    }
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      if (this.props.suggesting) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: 'handleAddTagClick',
    value: function handleAddTagClick() {
      var _this3 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          assetId = _props.asset;

      var message = this.refs.textarea.value;

      if (!message.length) {
        this.setState({
          error: false
        });
        (0, _setImmediate3.default)(function () {
          return _this3.setState({ error: true });
        });

        return;
      }

      dispatch((0, _assets.suggestTag)({ assetId: assetId, message: message }));
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var styles = require('./SuggestTagDialog.scss');
      var _props2 = this.props,
          suggesting = _props2.suggesting,
          suggested = _props2.suggested;


      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.SuggestTagDialog, true), (0, _defineProperty3.default)(_classnames, styles['SuggestTagDialog--error'], this.state.error), _classnames));

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: styles['SuggestTagDialog__inner'] },
          suggesting ? _react2.default.createElement(_components.LoadingIndicator, { className: styles['SuggestTagDialog__loading-indicator'] }) : suggested ? _react2.default.createElement(
            'div',
            { className: styles['SuggestTagDialog__success-message'] },
            'Thank you! We have your feedback regarding this asset. We\'ll take a look shortly!'
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: styles['SuggestTagDialog__question'] },
              'How would you like to tag this asset?'
            ),
            _react2.default.createElement('textarea', { ref: 'textarea', rows: '4', className: styles['SuggestTagDialog__textarea'] }),
            _react2.default.createElement(
              'div',
              { className: styles['SuggestTagDialog__buttons'] },
              _react2.default.createElement(_components.Button, { className: styles['SuggestTagDialog__button'], label: 'Cancel', onClick: this.handleCancelClick.bind(this) }),
              _react2.default.createElement(_components.Button, { primary: true, alternative: true, className: styles['SuggestTagDialog__button'], label: 'Add Tag', onClick: this.handleAddTagClick.bind(this) })
            )
          )
        )
      );
    }
  }]);
  return SuggestTagDialog;
}(_react2.default.Component)) || _class);
exports.default = SuggestTagDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SuggestTagDialog/SuggestTagDialog.jsx
// module id = 2442
// module chunks = 0